export default {
  login: {
    title: "Login",
    fields: {
      email: {
        label: "Email",
        placeholder: "example@mail.com"
      },
      password: {
        label: "Password",
        placeholder: "Password"
      }
    },
    rememberMe: "Remember me",
    forgotPassword: "Forgot password?",
    submit: "Sign in",
    submitting: "Signing in...",
    noAccount: "Not registered yet?",
    createAccount: "Create an account",
    errors: {
      emailRequired: "Email is required",
      passwordRequired: "Password is required",
      invalidCredentials: "Invalid email or password"
    }
  },
  register: {
    title: "Create an account",
    fields: {
      organizationName: {
        label: "Organization name",
        placeholder: "Your company name"
      },
      fullName: {
        label: "Full name",
        placeholder: "Your name"
      },
      email: {
        label: "Email",
        placeholder: "example@mail.com"
      },
      password: {
        label: "Password",
        placeholder: "Password (min. 6 characters)"
      },
      confirmPassword: {
        label: "Confirm password",
        placeholder: "Confirm your password"
      }
    },
    submit: "Sign up",
    submitting: "Signing up...",
    hasAccount: "Already have an account?",
    loginLink: "Login",
    errors: {
      organizationRequired: "Organization name is required",
      fullNameRequired: "Full name is required",
      emailRequired: "Email is required",
      passwordMinLength: "Password must be at least 6 characters",
      passwordMismatch: "Passwords do not match",
      registrationFailed: "Registration error"
    }
  }
};
